import { FC } from 'react';

import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import PricingCard from 'organisms/Cards/Pricing';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { HeroWithCardsConfigProps } from 'components/Hero/config';

import { hasArrayValues } from 'utils/array/arrays';

const HeroPricing: FC<HeroWithCardsConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { cards, body, buttons, eyebrow, heading, as } = rest;

  return (
    <Section {...sectionProps}>
      <div className="mx-auto flex flex-col items-center gap-16">
        <div className="max-w-[800px]">
          <Heading
            eyebrow={eyebrow}
            heading={heading}
            body={body}
            buttons={buttons}
            alignment="center"
            size="lg"
            as={as || 'h1'}
            animateOnMount
          />
        </div>
        <ScrollFadeSection delay={0.3} animateOnMount>
          <div className="flex w-full flex-col gap-8 lg:grid lg:grid-cols-3">
            {hasArrayValues(cards) && cards.map(card => <PricingCard key={card.id} {...card} />)}
          </div>
        </ScrollFadeSection>
      </div>
    </Section>
  );
};

export default HeroPricing;
